import React from 'react';
import { LibroDigitalPage } from './pages/LibroDigitalPage';
export function App() {
  return <LibroDigitalPage data-id="element-0" />;
}